import {
    DateFormatHelper,
    SoNumber,
    DetailItem,
    DetailSection,
    TransactionEnums,
    dateCompare,
    AppEnumHelper,
    formatName,
    DOMAIN_TYPES
} from "@/Shared";
import { TransactionModel } from "../TransactionModel";
import { AuditViewModel } from "@/Shared/Logic/ViewModels/AuditViewModel";
import { AuditModel } from "@/Shared/Logic/Models/AuditModel";
import { AccessRightModel } from "@/Domains";


export interface TransactionVMParams {
    transaction: TransactionModel;
    viewEnums: TransactionEnums;
    accessRight : AccessRightModel;
    isDisplaying : boolean;
}
export class TransactionViewModel {

    public id: number;
    public model : TransactionModel;
    public operationType!: string;
    public agencyCom!: string;
    public clientCom!: string;
    public ownerCom!: string;
    public comRate!: string;

    public transactionDate!: string;
    public bookingDate!: string;
    public createdAt!: string;

    public client!: string;
    public advisor!: string;

    public propertyId!: number;
    public propertyName!: string;
    public mandateId!: number;

    public operationPrice!: string;
    public owner!: string;
    public serviceChargeProvision!: string;
    public acMaintenanceCharge : string;
    public securityDeposit!: string;
    public audit!: AuditViewModel;
    public isDeleted : boolean;

    public cardHeaderTitle!: string;
    public cardClass!: string;

    public constructor(protected params : TransactionVMParams) {

        const {transaction, viewEnums,  accessRight, isDisplaying} = params;

        this.audit = new AuditViewModel(transaction as AuditModel);
        this.model = transaction;
        this.id = transaction?.id ?? 0;
        this.agencyCom = SoNumber.toFR(transaction.agencyCom ?? 0);
        this.clientCom = SoNumber.toFR(transaction.clientCom ?? 0);
        this.ownerCom = SoNumber.toFR(transaction.ownerCom ?? 0);
        this.comRate = SoNumber.toFR(transaction.comRate ?? 0);

        this.propertyId = transaction.propertyId ?? 0;

        this.propertyName = AppEnumHelper.getLabel(viewEnums.PropertyCategoryEnum, transaction.property?.propertyType);

        this.mandateId = transaction.mandateId ?? 0;

        this.operationPrice = SoNumber.toFR(transaction.operationPrice ?? 0);

        this.serviceChargeProvision = SoNumber.toFR(transaction.serviceChargeProvision ?? 0);

        this.acMaintenanceCharge = SoNumber.toFR(transaction.acMaintenanceCharge ?? 0);


        this.securityDeposit = SoNumber.toFR(transaction.securityDeposit ?? 0);

        this.client = formatName(transaction.client?.person);

        this.advisor = formatName(transaction.advisor?.person);

        this.owner = "";//..formatName(transaction.mandate?.contact?.person);


        this.transactionDate = DateFormatHelper.toLocaleString(transaction.transactionDate);
        this.bookingDate = DateFormatHelper.toLocaleString(transaction.bookingDate);

        this.createdAt = DateFormatHelper.toLocaleString(transaction.createdAt);

        this.operationType = AppEnumHelper.getLabel(viewEnums.OperationTypeEnum,transaction.mandate?.operationType);
        this.isDeleted = !!this.model.deletedAt;

        this.cardHeaderTitle = `${this.operationType.toUpperCase()} +  (ID : ${this.id})`;
        this.cardClass = isDisplaying ? 'active' : '';
    }

    get title() {
        return "Transaction N° " + this.id + " - " + this.operationType.toUpperCase();
    }


    getAllSections = (): DetailSection[] => {
        const sections: DetailSection[] = [
            {
                sectionFn: this.getTransactionSection,
                legend: 'Détails de la transaction',
                type: 'box'
            },
            {
                sectionFn: this.getFinancialSection,
                legend: 'éléments financiers',
                type: 'box'
            },
        ];
        if(this.params.accessRight.canAudit(DOMAIN_TYPES.Transaction)) {
            sections.push({
                sectionFn: this.audit.getAuditTrail,
                legend: 'Traçabilité',
                type: 'box'
            });
        }
        return sections;
    }

    getTransactionSection = () => {
        return [
            { label: "N° Transaction", value: this.id },
            { label: "N° Mandat", value: this.mandateId },
            { label: "N° Bien", value: this.propertyId },
            { label: "Type", value: this.operationType },
            { label: "Date Transaction", value: this.transactionDate },
            { label: "Date Réservation", value: this.bookingDate },
            { label: "Client", value: this.client },
            { label: "Propriétaire", value: this.owner },
            { label: "Conseillé Transact.", value: this.advisor },
        ] as DetailItem[];
    }

    getFinancialSection = () => {
        return [
            { label: "Loyers Prix Vente", value: this.operationPrice },
            { label: "Provisions/Charges", value: this.serviceChargeProvision },
            { label: "Entretien Climatisations", value: this.acMaintenanceCharge },
            { label: "Dépôt de garantit", value: this.securityDeposit },
            { label: "Taux Commission", value: this.comRate + '%' },
            { label: "Frais Préneur", value: this.clientCom },
            { label: "Frais Propriétaire", value: this.ownerCom },
            { label: "Frais agence TTC", value: this.agencyCom },
        ] as DetailItem[];
    }

    getMatchingSection = () => {
        const headers = ["N° Bien", "Nature du bien", "Type de bien", "Disponibilité"];

        const rows = [] as string[][];
        /*
        (transaction.properties ?? []).forEach(property =>
            rows.push([
                String(property.id),
                String(property.propertyCategory),
                String(property.propertyType),
                DateHelper.toLocaleString(property.availableAt) || ""
            ]));*/

        return { headers, rows };
    }

    compareTo(other: TransactionViewModel): number {
        return dateCompare(this.model.createdAt ?? "", other.model.createdAt ?? "");
    }
}